export default __webpack_public_path__ + "static/media/logo.da54afb8.png";